import React from "react";
import Image from "next/image";

class CustomCarousel extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      deviceType: this.getDeviceType(),
      currentIndex: 0,
      touchStartX: null,
      touchEndX: null,
    };
    this.handleResize = this.handleResize.bind(this);
    this.goToSlide = this.goToSlide.bind(this);
    this.nextSlide = this.nextSlide.bind(this);
    this.prevSlide = this.prevSlide.bind(this);
    this.startAutoplay = this.startAutoplay.bind(this);
    this.stopAutoplay = this.stopAutoplay.bind(this);
    this.handleTouchStart = this.handleTouchStart.bind(this);
    this.handleTouchMove = this.handleTouchMove.bind(this);
    this.handleTouchEnd = this.handleTouchEnd.bind(this);
    this.handleMouseDown = this.handleMouseDown.bind(this);
    this.handleMouseMove = this.handleMouseMove.bind(this);
    this.handleMouseUp = this.handleMouseUp.bind(this);
    this.autoplayInterval = null;
  }

  getDeviceType() {
    if (typeof window === "undefined") return "desktop";
    const width = window.innerWidth;
    if (width < 768) return "mobile";
    if (width < 1024) return "tablet";
    return "desktop";
  }

  componentDidMount() {
    window.addEventListener("resize", this.handleResize);
    const carouselWrapper = this.carouselWrapper;
    if (carouselWrapper) {
      carouselWrapper.addEventListener("touchstart", this.handleTouchStart, {
        passive: true,
      });
      carouselWrapper.addEventListener("touchmove", this.handleTouchMove, {
        passive: true,
      });
      carouselWrapper.addEventListener("touchend", this.handleTouchEnd, {
        passive: true,
      });
      carouselWrapper.addEventListener("mousedown", this.handleMouseDown);
      carouselWrapper.addEventListener("mousemove", this.handleMouseMove);
      carouselWrapper.addEventListener("mouseup", this.handleMouseUp);
      carouselWrapper.addEventListener("mouseleave", this.handleMouseUp);
    }
    if (this.props.autoplay) this.startAutoplay();
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.handleResize);
    const carouselWrapper = this.carouselWrapper;
    if (carouselWrapper) {
      carouselWrapper.removeEventListener("touchstart", this.handleTouchStart);
      carouselWrapper.removeEventListener("touchmove", this.handleTouchMove);
      carouselWrapper.removeEventListener("touchend", this.handleTouchEnd);
      carouselWrapper.removeEventListener("mousedown", this.handleMouseDown);
      carouselWrapper.removeEventListener("mousemove", this.handleMouseMove);
      carouselWrapper.removeEventListener("mouseup", this.handleMouseUp);
      carouselWrapper.removeEventListener("mouseleave", this.handleMouseUp);
    }
    this.stopAutoplay();
  }

  handleResize() {
    this.setState({ deviceType: this.getDeviceType() });
  }

  goToSlide(idx) {
    this.setState({ currentIndex: idx }, () => {
      console.log(
        "Go to slide:",
        idx,
        "Banners length:",
        this.props.banners.length
      );
    });
    if (this.props.autoplay) {
      this.stopAutoplay();
      this.startAutoplay();
    }
  }

  nextSlide() {
    const { banners } = this.props;
    const itemsToShow = this.getItemsToShow();
    const slidesToSlide = this.getSlidesToSlide();
    this.setState(
      (prevState) => ({
        currentIndex: (prevState.currentIndex + slidesToSlide) % banners.length,
      }),
      () => {
        console.log("Next slide index:", this.state.currentIndex);
      }
    );
    if (this.props.autoplay) {
      this.stopAutoplay();
      this.startAutoplay();
    }
  }

  prevSlide() {
    const { banners } = this.props;
    const itemsToShow = this.getItemsToShow();
    const slidesToSlide = this.getSlidesToSlide();
    this.setState(
      (prevState) => ({
        currentIndex:
          (prevState.currentIndex - slidesToSlide + banners.length) %
          banners.length,
      }),
      () => {
        console.log("Prev slide index:", this.state.currentIndex);
      }
    );
    if (this.props.autoplay) {
      this.stopAutoplay();
      this.startAutoplay();
    }
  }

  startAutoplay() {
    if (this.props.autoplay) {
      this.autoplayInterval = setInterval(this.nextSlide, 3000);
    }
  }

  stopAutoplay() {
    if (this.autoplayInterval) {
      clearInterval(this.autoplayInterval);
    }
  }

  getItemsToShow() {
    const width = typeof window !== "undefined" ? window.innerWidth : 1024; // Fallback for SSR
    const responsive = this.props.responsive || {
      desktop: { breakpoint: { max: 3000, min: 1024 }, items: 1 },
      tablet: {
        breakpoint: { max: 1024, min: 464 },
        items: 2,
        slidesToSlide: 2,
      },
      mobile: { breakpoint: { max: 464, min: 0 }, items: 1, slidesToSlide: 1 },
    };
    if (width >= 1024 && width <= 3000)
      return Math.round(responsive.desktop.items);
    if (width >= 464 && width < 1024)
      return Math.round(responsive.tablet.items);
    return Math.round(responsive.mobile.items); // width < 464
  }

  getSlidesToSlide() {
    const width = typeof window !== "undefined" ? window.innerWidth : 1024; // Fallback for SSR
    const responsive = this.props.responsive || {
      desktop: { breakpoint: { max: 3000, min: 1024 }, items: 1 },
      tablet: {
        breakpoint: { max: 1024, min: 464 },
        items: 2,
        slidesToSlide: 2,
      },
      mobile: { breakpoint: { max: 464, min: 0 }, items: 1, slidesToSlide: 1 },
    };
    if (width >= 1024 && width <= 3000)
      return responsive.desktop.slidesToSlide || 1;
    if (width >= 464 && width < 1024)
      return responsive.tablet.slidesToSlide || 1;
    return responsive.mobile.slidesToSlide || 1; // width < 464
  }

  handleTouchStart(e) {
    this.setState({ touchStartX: e.touches[0].clientX });
  }

  handleTouchMove(e) {
    this.setState({ touchEndX: e.touches[0].clientX });
  }

  handleTouchEnd() {
    const { touchStartX, touchEndX } = this.state;
    if (touchStartX && touchEndX) {
      const diff = touchStartX - touchEndX;
      if (diff > 50) this.nextSlide();
      else if (diff < -50) this.prevSlide();
    }
    this.setState({ touchStartX: null, touchEndX: null });
  }

  handleMouseDown(e) {
    this.setState({ touchStartX: e.clientX });
  }

  handleMouseMove(e) {
    if (this.state.touchStartX) {
      this.setState({ touchEndX: e.clientX });
    }
  }

  handleMouseUp() {
    const { touchStartX, touchEndX } = this.state;
    if (touchStartX && touchEndX) {
      const diff = touchStartX - touchEndX;
      if (diff > 50) this.nextSlide();
      else if (diff < -50) this.prevSlide();
    }
    this.setState({ touchStartX: null, touchEndX: null });
  }

  render() {
    const {
      banners = [],
      imageLoader,
      cssstyles,
      arrows = false,
      dots = true,
      autoplay = false,
      imageKey = "image",
      prevArrow = "←",
      nextArrow = "→",
    } = this.props;
    const { deviceType, currentIndex } = this.state;
    const css = cssstyles;
    const itemsToShow = this.getItemsToShow();
    const totalSlides = Math.ceil(banners.length / itemsToShow);
    if (!banners.length) {
      return <div className={css.nobanner}></div>;
    }
    const visibleBanners = banners.slice(
      currentIndex * itemsToShow,
      (currentIndex + 1) * itemsToShow
    );

    return (
      <div
        className={`${css?.carousal_container}  carousal_container`}
        onMouseEnter={autoplay ? this.stopAutoplay : null}
        onMouseLeave={autoplay ? this.startAutoplay : null}
      >
        <div
          className={`${css?.carousel_wrapper}  carousel_wrapper`}
          ref={(el) => (this.carouselWrapper = el)}
        >
          {arrows && (
            <button
              className={`${css?.carousel_arrow}  carousel_arrowprev`}
              onClick={this.prevSlide}
              aria-label="Previous"
            >
              {prevArrow}
            </button>
          )}
          {visibleBanners.map((banner, index) => {
            // Use imageLoader prop to get the final image src
            let rawSrc = banner[imageKey] || banner.r_image || "";
            const imageSrc = this.props.imageLoader
              ? this.props.imageLoader({ src: rawSrc })
              : rawSrc;
            return (
              <div
                key={"banner" + (currentIndex * itemsToShow + index)}
                className={`${css?.carousel_item}  carousel_item`}
              >
                <img src={imageSrc} alt={banner.alt || "carousel-image"} />
              </div>
            );
          })}
          {arrows && (
            <button
              className={`${css?.carousel_arrow}  carousel_arrownext`}
              onClick={this.nextSlide}
              aria-label="Next"
            >
              {nextArrow}
            </button>
          )}
        </div>
        {dots ? (
          <div className={`${css?.carousel_indicators}  carousel_indicators`}>
            {Array.from({ length: totalSlides }).map((_, idx) => (
              <span
                key={idx}
                className={`${
                  idx === currentIndex
                    ? `${css?.active_indicator} active_indicator`
                    : `${css?.indicator} indicator`
                }`}
                onClick={() => this.goToSlide(idx)}
              ></span>
            ))}
          </div>
        ) : (
          <div className={`${css?.carousal_blankimg}  carousal_blankimg`}></div>
        )}
      </div>
    );
  }
}

export default CustomCarousel;
